// This is a base64 version of https://thewest.com.au/static/media/feature_detection_video.mp4
const videoSrc =
    'data:video/mp4;base64,AAAAIGZ0eXBpc29tAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAAAxFtZGF03gIATGF2YzU4LjE4LjEwMABCIAjBGDgAAAKuBgX//6rcRem95tlIt5Ys2CDZI+7veDI2NCAtIGNvcmUgMTUyIHIyODU0IGU5YTU5MDMgLSBILjI2NC9NUEVHLTQgQVZDIGNvZGVjIC0gQ29weWxlZnQgMjAwMy0yMDE3IC0gaHR0cDovL3d3dy52aWRlb2xhbi5vcmcveDI2NC5odG1sIC0gb3B0aW9uczogY2FiYWM9MSByZWY9MyBkZWJsb2NrPTE6MDowIGFuYWx5c2U9MHgzOjB4MTEzIG1lPWhleCBzdWJtZT03IHBzeT0xIHBzeV9yZD0xLjAwOjAuMDAgbWl4ZWRfcmVmPTEgbWVfcmFuZ2U9MTYgY2hyb21hX21lPTEgdHJlbGxpcz0xIDh4OGRjdD0xIGNxbT0wIGRlYWR6b25lPTIxLDExIGZhc3RfcHNraXA9MSBjaHJvbWFfcXBfb2Zmc2V0PS0yIHRocmVhZHM9NCBsb29rYWhlYWRfdGhyZWFkcz0xIHNsaWNlZF90aHJlYWRzPTAgbnI9MCBkZWNpbWF0ZT0xIGludGVybGFjZWQ9MCBibHVyYXlfY29tcGF0PTAgY29uc3RyYWluZWRfaW50cmE9MCBiZnJhbWVzPTMgYl9weXJhbWlkPTIgYl9hZGFwdD0xIGJfYmlhcz0wIGRpcmVjdD0xIHdlaWdodGI9MSBvcGVuX2dvcD0wIHdlaWdodHA9MiBrZXlpbnQ9MjUwIGtleWludF9taW49MTAgc2NlbmVjdXQ9NDAgaW50cmFfcmVmcmVzaD0wIHJjX2xvb2thaGVhZD00MCByYz1jcmYgbWJ0cmVlPTEgY3JmPTIzLjAgcWNvbXA9MC42MCBxcG1pbj0wIHFwbWF4PTY5IHFwc3RlcD00IGlwX3JhdGlvPTEuNDAgYXE9MToxLjAwAIAAAAA2ZYiEADf//uED+BTPe/mMat1RZaYVy5G3EpdM2fOQGI9eKCTIrCoXVhOwo7+AAWYAFQEZ5/qFIRAEYIwcAAAFJ21vb3YAAABsbXZoZAAAAAAAAAAAAAAAAAAAA+gAAABkAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAIodHJhawAAAFx0a2hkAAAAAwAAAAAAAAAAAAAAAQAAAAAAAABkAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAACwAAAAkAAAAAAAJGVkdHMAAAAcZWxzdAAAAAAAAAABAAAAZAAAAAAAAQAAAAABoG1kaWEAAAAgbWRoZAAAAAAAAAAAAAAAAAAAKAAAAAQAVcQAAAAAAC1oZGxyAAAAAAAAAAB2aWRlAAAAAAAAAAAAAAAAVmlkZW9IYW5kbGVyAAAAAUttaW5mAAAAFHZtaGQAAAABAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAAELc3RibAAAAKdzdHNkAAAAAAAAAAEAAACXYXZjMQAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAACwAJAASAAAAEgAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj//wAAADFhdmNDAWQACv/hABhnZAAKrNlCxOwEQAAAAwBAAAAFA8SJZYABAAZo6+PLIsAAAAAQcGFzcAAAAAEAAAABAAAAGHN0dHMAAAAAAAAAAQAAAAEAAAQAAAAAHHN0c2MAAAAAAAAAAQAAAAEAAAABAAAAAQAAABRzdHN6AAAAAAAAAuwAAAABAAAAFHN0Y28AAAAAAAAAAQAAAEcAAAIpdHJhawAAAFx0a2hkAAAAAwAAAAAAAAAAAAAAAgAAAAAAAAAvAAAAAAAAAAAAAAABAQAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAJGVkdHMAAAAcZWxzdAAAAAAAAAABAAAAFwAABAAAAQAAAAABoW1kaWEAAAAgbWRoZAAAAAAAAAAAAAAAAAAArEQAAAgAVcQAAAAAAC1oZGxyAAAAAAAAAABzb3VuAAAAAAAAAAAAAAAAU291bmRIYW5kbGVyAAAAAUxtaW5mAAAAEHNtaGQAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAARBzdGJsAAAAanN0c2QAAAAAAAAAAQAAAFptcDRhAAAAAAAAAAEAAAAAAAAAAAACABAAAAAArEQAAAAAADZlc2RzAAAAAAOAgIAlAAIABICAgBdAFQAAAAAB9AAAABODBYCAgAUSEFblAAaAgIABAgAAABhzdHRzAAAAAAAAAAEAAAACAAAEAAAAABxzdHNjAAAAAAAAAAEAAAABAAAAAQAAAAEAAAAcc3RzegAAAAAAAAAAAAAAAgAAABcAAAAGAAAAGHN0Y28AAAAAAAAAAgAAADAAAAMzAAAAGnNncGQBAAAAcm9sbAAAAAIAAAAB//8AAAAcc2JncAAAAAByb2xsAAAAAQAAAAIAAAABAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1OC4xMi4xMDA='

/**
 * Testing autoplay relies on us to play a video and catch the result of the returned promise. In our designs,
 * we don't want to play the video immediately, so instead we load a test video and attempt to play that. The video
 * must have a src else the promise returned from .play() will never return. The play() api does not always return
 * a promise in older browsers - but awaiting it will have the same effect (i.e. don't use the .then api).
 */

let overrideAutoplayCheck: undefined | AutoplayAllowState

export enum AutoplayAllowState {
    CanAutoplay,
    CanAutoplayMuted,
    CannotAutoplay,
}

/** Globally override the autoplay check, assuming it's not blocked */
export function setAutoplayOverride(state: AutoplayAllowState) {
    overrideAutoplayCheck = state
}

/**
 * Override the autoplay check when testing in dev console
 * e.g window.setAutoplayOverride(1) will explicitly set muted autoplay only
 */
if (typeof window !== 'undefined') {
    ;(window as any).setAutoplayOverride = setAutoplayOverride
}

export const isMobile = {
    Android: () => {
        return navigator.userAgent.match(/Android/i)
    },
    BlackBerry: () => {
        return navigator.userAgent.match(/BlackBerry/i)
    },
    iOS: () => {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)
    },
    Opera: () => {
        return navigator.userAgent.match(/Opera Mini/i)
    },
    Windows: () => {
        return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
        )
    },
    any: () => {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        )
    },
}

export function isSafariDesktop() {
    return (
        typeof navigator !== 'undefined' &&
        !isMobile.any() &&
        navigator.userAgent.match('Safari') &&
        !navigator.userAgent.match('Chrom(e|ium)')
    )
}

type VideoAutoPlayOptions = {
    forceEnableAutoplay?: boolean
}
export async function videoCanAutoplay({
    forceEnableAutoplay,
}: VideoAutoPlayOptions): Promise<AutoplayAllowState> {
    try {
        if (overrideAutoplayCheck !== undefined) {
            return overrideAutoplayCheck
        }

        if (forceEnableAutoplay) {
            return AutoplayAllowState.CanAutoplayMuted
        }

        // iFruit devices mostly use the native player. This can change in iOS 10
        // but not worth messing around. Just disable autoplay test on those devices
        if (isMobile.any()) {
            return AutoplayAllowState.CannotAutoplay
        }

        const videoEl = document.createElement('video')
        videoEl.muted = true
        videoEl.src = videoSrc

        await videoEl.play()
        // The video el created will only get garbage collected if it's paused or completed
        videoEl.pause()

        return AutoplayAllowState.CanAutoplay
    } catch (e) {
            return AutoplayAllowState.CannotAutoplay
    }
}
